import { useLanguage } from "@/contexts/LanguageContext";
import { useAuth } from "@/contexts/AuthContext";
import { Globe } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";

export default function LanguageSwitcher({ align = "end" }) {
  const { lang, setLang, langs, t } = useLanguage();
  const auth = useAuth();

  const handleChange = async (code) => {
    setLang(code);
    if (auth?.user && typeof auth.user === "object") {
      await auth.setPreferredLanguage(code);
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        className="inline-flex items-center gap-2 px-3 h-9 rounded-sm border border-border hover:border-primary/60 text-secondary-foreground hover:text-primary transition-colors font-mono text-xs tracking-widest"
        data-testid="lang-switcher-trigger"
      >
        <Globe className="w-3.5 h-3.5" />
        {langs.find((l) => l.code === lang)?.short || "EN"}
      </DropdownMenuTrigger>
      <DropdownMenuContent align={align} className="bg-card border-border min-w-[200px]">
        <DropdownMenuLabel className="font-mono text-[10px] tracking-[0.22em] text-muted-foreground uppercase">
          {t("common.language")}
        </DropdownMenuLabel>
        <DropdownMenuSeparator className="bg-border" />
        {langs.map((l) => (
          <DropdownMenuItem
            key={l.code}
            onClick={() => handleChange(l.code)}
            data-testid={`lang-switcher-${l.code}`}
            className={`cursor-pointer flex items-center justify-between ${l.code === lang ? "text-primary" : ""}`}
          >
            <span>{l.label}</span>
            <span className="font-mono text-[10px] tracking-widest opacity-60">{l.short}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
